module.exports = __webpack_public_path__ + "static/media/apple-homekit.54e60f73.jpg";